export const instruments = {
    instrument1: {
        solventMapping: {
            CDCl3: 'CDCl3',
            'DMSO-d6': 'DMSO-d6',
        },
        defaultExperiments: [
            { key: '1H', isPolymer: false, experiment: '1H_CSE_LL' },
            { key: '13C', isPolymer: false, experiment: '13C{1H}_CSE_LL' },
            { key: 'COSY', isPolymer: false, experiment: 'COSY_NUS_CSE_LL' },
            { key: 'HSQC', isPolymer: false, experiment: 'HSQCed_NUS_CSE_LL' },
            { key: 'HMBC', isPolymer: false, experiment: 'HMBC_NUS_CSE_LL' },
            { key: 'NOESY', isPolymer: false, experiment: 'NOESY' },
            { key: '31P', isPolymer: false, experiment: '31P{1H}' },
            { key: '11B', isPolymer: false, experiment: '11B{1H}' },
            { key: '13C', isPolymer: true, experiment: '13C{1H}_POLYMER' },
            { key: 'APT', isPolymer: true, experiment: '13C{1H}-APT-POLY' },
            { key: 'DEPT135', isPolymer: true, experiment: 'DEPT135-POLYMER' },
        ],
        experiments: [
            {
                experiment: '1H_CSE_LL',
                parameters: [
                    { label: 'd1', value: '1.2' },
                    { label: 'td', value: '64k' },
                    { label: 'o1p', value: '6.5' },
                    { label: 'sw', value: '20' },
                    { label: 'ns', value: '16' },
                    { label: 'ds', value: '2' },
                ],
            },
            {
                experiment: '13C{1H}_CSE_LL',
                parameters: [
                    { label: 'd1', value: '2.5' },
                    { label: 'td', value: '64k' },
                    { label: 'o1p', value: '115' },
                    { label: 'sw', value: '282' },
                    { label: 'ns', value: '128' },
                    { label: 'ds', value: '4' },
                ],
            },
            {
                experiment: 'DEPT135',
                parameters: [
                    { label: 'd1', value: '2' },
                    { label: 'td', value: '64k' },
                    { label: 'o1p', value: '115' },
                    { label: 'sw', value: '282' },
                    { label: 'ns', value: '128' },
                    { label: 'ds', value: '8' },
                ],
            },
            {
                experiment: '13C_APT',
                parameters: [
                    { label: 'd1', value: '2' },
                    { label: 'td', value: '64k' },
                    { label: 'o1p', value: '100' },
                    { label: 'sw', value: '282' },
                    { label: 'ns', value: '256' },
                    { label: 'ds', value: '4' },
                    { label: 'cnst2', value: '145' },
                ],
            },
            {
                experiment: '1H_gradsup',
                parameters: [
                    { label: 'd1', value: '2' },
                    { label: 'td', value: '64k' },
                    { label: 'o1p', value: '4.7' },
                    { label: 'sw', value: '24' },
                    { label: 'ns', value: '32' },
                    { label: 'ds', value: '26' },
                ],
            },
            {
                experiment: 'COSY_NUS_CSE_LL',
                parameters: [
                    { label: 'd1', value: '1.5' },
                    { label: 'td', value: '2k' },
                    { label: 'o1p', value: '6.5' },
                    { label: 'sw', value: '15' },
                    { label: 'ns', value: '4' },
                    { label: 'ds', value: '16' },
                ],
            },
            {
                experiment: 'HSQCed_NUS_CSE_LL',
                parameters: [
                    { label: 'd1', value: '1.2' },
                    { label: 'td', value: '2k' },
                    { label: 'o1p', value: '6.5' },
                    { label: 'sw', value: '15' },
                    { label: 'ns', value: '4' },
                    { label: 'ds', value: '16' },
                    { label: 'cnst2', value: '145' },
                ],
            },
            {
                experiment: 'HMBC_NUS_CSE_LL',
                parameters: [
                    { label: 'd1', value: '1.5' },
                    { label: 'td', value: '1k' },
                    { label: 'o1p', value: '6.5' },
                    { label: 'sw', value: '15' },
                    { label: 'ns', value: '8' },
                    { label: 'ds', value: '16' },
                    { label: 'cnst6', value: '120' },
                    { label: 'cnst7', value: '170' },
                    { label: 'cnst13', value: '8' },
                ],
            },
            {
                experiment: 'NOESY',
                parameters: [
                    { label: 'd1', value: '2' },
                    { label: 'td', value: '2k' },
                    { label: 'o1p', value: '6.5' },
                    { label: 'sw', value: '15' },
                    { label: 'ns', value: '32' },
                    { label: 'ds', value: '16' },
                    { label: 'd8', value: '0.3' },
                ],
            },
            {
                experiment: '31P{1H}',
                parameters: [
                    { label: 'd1', value: '2' },
                    { label: 'td', value: '64k' },
                    { label: 'o1p', value: '0' },
                    { label: 'sw', value: '400' },
                    { label: 'ns', value: '256' },
                    { label: 'ds', value: '4' },
                ],
            },
            {
                experiment: '11B{1H}',
                parameters: [
                    { label: 'd1', value: '2' },
                    { label: 'td', value: '64k' },
                    { label: 'o1p', value: '0' },
                    { label: 'sw', value: '300' },
                    { label: 'ns', value: '256' },
                    { label: 'ds', value: '4' },
                ],
            },
            {
                experiment: '13C{1H}_POLYMER',
                parameters: [
                    { label: 'd1', value: '0.7' },
                    { label: 'td', value: '16k' },
                    { label: 'o1p', value: '115' },
                    { label: 'sw', value: '282' },
                    { label: 'ns', value: '10k' },
                    { label: 'ds', value: '4' },
                ],
            },
            {
                experiment: '13C{1H}-APT-POLY',
                parameters: [
                    { label: 'd1', value: '0.7' },
                    { label: 'td', value: '16k' },
                    { label: 'o1p', value: '115' },
                    { label: 'sw', value: '282' },
                    { label: 'ns', value: '10k' },
                    { label: 'ds', value: '4' },
                    { label: 'cnst2', value: '145' },
                ],
            },
            {
                experiment: 'DEPT135-POLYMER',
                parameters: [
                    { label: 'd1', value: '0.75' },
                    { label: 'td', value: '16k' },
                    { label: 'o1p', value: '115' },
                    { label: 'sw', value: '282' },
                    { label: 'ns', value: '2500' },
                    { label: 'ds', value: '8' },
                ],
            },
        ],
    },
    instrument2: {
        solventMapping: {
            CDCl3: 'Chloroform-d',
            'DMSO-d6': 'Dimethyl sulfoxide-d6',
        },
        defaultExperiments: [
            { key: '1h', isPolymer: false, experiment: 'H1 NMR' },
            { key: '13c', isPolymer: false, experiment: 'C13 NMR' },
            { key: 'hsqc', isPolymer: false, experiment: 'HSQC' },
        ],
        experiments: [
            {
                experiment: 'H1 NMR',
                parameters: [
                    { label: 'd1', value: '' },
                    { label: 'number of scans', value: '' },
                ],
            },
            {
                experiment: 'C13 NMR',
                parameters: [
                    { label: 'ds', value: '' },
                    { label: 'ns', value: '' },
                    { label: 'd1', value: '' },
                ],
            },
            {
                experiment: 'HSQC',
                parameters: [],
            },
        ],
    },
};
//# sourceMappingURL=instruments.js.map